"use strict";
export function isImeKey(event) {
  return event.isComposing || event.keyCode === 229;
}
